/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import { Button, TextField } from '@mui/material';
import LegacyGrid from './legacy/LegacyGrid';
import { withStyles } from '@mui/styles';
import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getHelpButtons, navigationButtonStyle } from '../common/common';
import { actionCreators } from '../store/UploadManual';

interface Props {
    classes: any
    back: any
    helpButtons: any
    UpdateHelpButtons: Function,
    handleHelpLinksChange: Function
    [key: number]: number
    helpLinkAssignments: any
    handleSubmit: any
}
const styles = () => ({
    input: {
        backgroundColor: '#fff'
    },
    navigationButton: navigationButtonStyle
});

class AssignHelpButtonToManual extends React.Component<Props, {}> {
    async componentDidMount() {
        if (this.props.helpButtons.length === 0) {
            const response = await getHelpButtons();
            this.props.UpdateHelpButtons(response);
        }
    }
    handleChange = (event: any) => {
        this.props.handleHelpLinksChange(event);
    };
    renderHelpButtonSelection = (id: any, value: any, classes: any) => {
        let pn: any = '';
        if (this.props.helpLinkAssignments !== undefined) {
            pn = this.props.helpLinkAssignments[id];
        }
        return (<LegacyGrid key={id} container className="helpButtons">
            <TextField
                id={id + ''}
                type="number"
                InputLabelProps={{
                    shrink: true,
                }}
                variant="outlined"
                onChange={(event: any) => {
                    if (event.target.value < 0) {
                        event.target.value = '';
                    }
                    else {
                        this.handleChange(event);
                    }
                }}
                value={pn}
                InputProps={{ classes: { input: classes.input } }}
                size="medium"
                sx={{ width: 220, backgroundColor: '#fff' }}
            />
            <p className="helpButtonDescription">{value}</p>
        </LegacyGrid>
        );
    };

    render() {
        const { classes } = this.props;
        return (
            <LegacyGrid className="classificationGrid">
                <LegacyGrid className="classificationGridTitle">4.Assign Help Link to manual </LegacyGrid>
                <LegacyGrid className="helpButtonContainer">
                    {
                        this.props.helpButtons.map((x: any) => {
                            return (
                                this.renderHelpButtonSelection(x.helpbuttonid, x.description, classes)
                            );
                        })
                    }
                </LegacyGrid>
                <LegacyGrid container justify="flex-end" className="navigatiobuttonGridHelpLink">
                    <Button className={classes.navigationButton} onClick={this.props.back}>Previous</Button>
                    <Button className={classes.navigationButton} onClick={this.props.handleSubmit}>Done</Button>
                </LegacyGrid>
            </LegacyGrid>
        );
    }
}

const mapStateToProps = (state: any) => ({
    state: state.uploadManual,
    helpButtons: state.uploadManual.helpButtons,
    helpLinkAssignments: state.uploadManual.helpLinkAssignments
});

const mapDispatchtoProps = (dispatch: any) =>
    bindActionCreators(actionCreators, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchtoProps
)
    (withStyles(styles)(AssignHelpButtonToManual));
